<template>
	<!-- 保险基数管理 -->
	<div>
		<div v-show="Bxjsgl">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">保险基数管理</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>

					<div style="display:inline-block;margin-left:10px">
						<span>城市 </span>
						<el-select v-model="condition.city_id" style="margin-left:10px;width:200px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
								:value="item.city">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-left:30px">
						<span>最低工资 </span>
						<el-input v-model="condition.minimum_wage" style="margin-left:10px;width:200px"
							placeholder="请输入最低工资"></el-input>
					</div>

					<!-- 按钮 -->
					<div style="display:inline-block; float:right; margin-right: 5%;">
						<el-button type="goon" @click="Find">查询</el-button>
						<el-button type="goon" @click="Del(null)">删除</el-button>
						<el-button type="addbtn" @click="add">新增</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%">
					<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
						</el-table-column>
						<el-table-column prop="city_id" align="center" label="城市"></el-table-column>
						<el-table-column prop="minimum_wage" align="center" label="最低工资"></el-table-column>
						<el-table-column align="center" label="操作" width="150" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/编辑.png" @click="xiugai(scope.row)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<el-dialog title="新增" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false" :center="true" :before-close="handleClose">
			<add ref="add"></add>
		</el-dialog>
		<el-dialog title="修改" :visible.sync="dialogVisibles" width="60%" :close-on-click-modal="false" :center="true">
			<xiugai ref="xiugai"></xiugai>
		</el-dialog>
	</div>

</template>

<script>
import add from './Bxjsgl_add.vue'
import edit from './Bxjsgl_edit.vue'
import xiugai from './Bxjsgl_xiugai.vue'
import axios from 'axios';
export default {
	components: {
		add: add,
		edit: edit,
		xiugai: xiugai,
	},
	data() {
		return {
			//列表相关
			page_num: 1,
			page_size: 10,
			total: 0,
			tableData: [],

			//条件
			condition: {
				city_id: '',
				minimum_wage: '',
			},

			//详情
			ruleForm: {
				id: '',
			},
			form: {
				id: '',
				city_id: '',
				minimum_wage: '',
				// 养老
				provideAged_base: '',
				provideAged_pay_type: '',
				provideAged_proportion: '',
				// 失业
				unemployment_base: '',
				unemployment_pay_type: '',
				unemployment_proportion: '',
				// 工伤
				industrial_injury_base: '',
				industrial_injury_type: '',
				industrial_injury_proportion: '',
				// 医疗
				medical_care_base: '',
				medical_care_pay_type: '',
				medical_care_proportion: '',
				// 生育
				birth_base: '',
				birth_pay_type: '',
				birth_proportion: '',
				// 大额医疗
				large_treatment_base: '',
				large_treatment_pay_type: '',
				large_treatment_proportion: '',
				large_treatment_month: '',
				// 公积金
				commonMpe_base: '',
				commonMpe_pay_type: '',
				commonMpe_proportion: '',
				// 公司缴费比例
				// companyList: [{
				// 	pay_company: '',
				// 	pay_proportion: '',
				// 	flag: 0
				// }],

				companyList: [],
				companyCount: [1],
			},

			//页面相关
			dialogVisible: false,
			dialogVisibles: false,
			showedit: false,
			Bxjsgl_edit: false,
			imgUrl: "",

			// 权限
			Bxjsgl: true,
			Data: [],


			//删除ids
			ids: [],
		};
	},
	methods: {
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		//返回
		Return(e) {
			this.dialogVisible = false;
			this.dialogVisibles = false;
			this.Find();
		},
		handleClose(){
			console.log(22222222222222222222222)
			this.$refs.add.qingkongson();
			this.Return();
		},
		// 新增
		add() {
			this.qingkong();
			
			this.dialogVisible = true;
		},
		async xiugai(e) {
			this.form.id = e.id;
			this.form.city_id = e.city_id;
			this.form.minimum_wage = e.minimum_wage;
			this.dialogVisibles = true;
			var url = '/InsuranceBase/selectDetails';
			var record = {
				id: e.id,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.Data = data;
					this.total = data.total;
					// 养老
					this.form.provideAged_base = this.Data.provideAged_base;
					this.form.provideAged_pay_type = this.Data.provideAged_pay_type;
					this.form.provideAged_proportion = this.Data.provideAged_proportion;
					// 失业
					this.form.unemployment_base = this.Data.unemployment_base;
					this.form.unemployment_pay_type = this.Data.unemployment_pay_type;
					this.form.unemployment_proportion = this.Data.unemployment_proportion;
					// 工伤
					this.form.industrial_injury_base = this.Data.industrial_injury_base;
					this.form.industrial_injury_type = this.Data.industrial_injury_type;
					this.form.industrial_injury_proportion = this.Data.industrial_injury_proportion;
					// 医疗
					this.form.medical_care_base = this.Data.medical_care_base;
					this.form.medical_care_pay_type = this.Data.medical_care_pay_type;
					this.form.medical_care_proportion = this.Data.medical_care_proportion;
					// 生育
					this.form.birth_base = this.Data.birth_base;
					this.form.birth_pay_type = this.Data.birth_pay_type;
					this.form.birth_proportion = this.Data.birth_proportion;
					// 大额医疗
					this.form.large_treatment_base = this.Data.large_treatment_base;
					this.form.large_treatment_pay_type = this.Data.large_treatment_pay_type;
					this.form.large_treatment_proportion = this.Data.large_treatment_proportion;
					this.form.large_treatment_month = this.Data.large_treatment_month;
					// 公积金
					this.form.commonMpe_base = this.Data.commonMpe_base;
					this.form.commonMpe_pay_type = this.Data.commonMpe_pay_type;
					this.form.commonMpe_proportion = this.Data.commonMpe_proportion;
					// debugger
					this.form.companyList = this.Data.companyList;

					if (this.Data.companyList.length > 0) {
						this.form.companyList = this.Data.companyList;
						this.form.companyCount.length = this.Data.companyList.length;
					} else {
						this.form.companyList = [{
							pay_company: '',
							pay_provideAged: '',
							pay_unemployment: '',
							pay_industrial_injury: '',
							pay_medical_care: '',
							pay_birth: '',
							pay_large_treatment: '',
							pay_commonMpe: '',
							flag: 0
						}];
						this.form.companyCount = [1];
					}
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}

			// // 公司缴费比例
			// this.form.companyList = e.companyList;

		},
		//详情
		// async edit(e) {
		// 	this.Bxjsgl = false;
		//     this.showedit = true;
		// 	var url = '/InsuranceBase/selectDetails';
		// 	var record = {
		// 		id: e,
		// 	};
		// 	var data = await this.$globals.AxiosPost(url, record);
		// 	if (data === '-2000') {
		// 		this.$message.error('服务器未响应！请稍后重试');
		// 	} else {
		// 		var code = data.code;
		// 		var data = data.data;
		// 		if (code === '200') {
		// 			this.tableData = data.list;
		// 			this.total = data.total;
		// 		} else {
		// 			this.$message.warning('请求失败！请稍后重试');
		// 		}
		// 	}
		// },
		//查询
		async Find() {
			var url = '/InsuranceBase/select';
			var record = {
				page_num: this.page_num,
				page_size: this.page_size,
				city_id: this.condition.city_id,
				minimum_wage: this.condition.minimum_wage,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.tableData = data.list;
					this.total = data.total;
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		// 操作删除
		async Del(e) {
			var ids;
			if (e === null || e === "" || e === undefined) {
				if (this.ids === null || this.ids.length <= 0) {
					this.$message.warning("请先选择操作数据！");
					return false;
				}
				ids = this.ids;
			} else {
				ids = [e];
			}

			var url = "/InsuranceBase/del";
			var record = {
				ids: ids,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
		},

		//分页
		handleCurrentChange(val) {
			this.page_num = val;
			this.Find();
		},
		Return() {
			this.dialogVisible = false;
			this.dialogVisibles = false;
			this.Bxjsgl = true;
			this.Bxjsgl_edit = false;
			this.Find();
		},
		qingkong() {

			// 公司缴费比例
			this.form.companyList = [{}];
			this.form.companyCount = [1];
            // this.form.companyList.pay_company = '';
            // this.form.companyList.pay_provideAged = '';
            // this.form.companyList.pay_unemployment = '';
            // this.form.companyList.pay_industrial_injury = '';
            // this.form.companyList.pay_medical_care = '';
            // this.form.companyList.pay_birth = '';
            // this.form.companyList.pay_large_treatment = '';
            // this.form.companyList.pay_commonMpe = '';
            // this.form.companyList.flag = 0;
			// this.form.companyList = [{
			// 				pay_company: '',
			// 				pay_provideAged: '',
			// 				pay_unemployment: '',
			// 				pay_industrial_injury: '',
			// 				pay_medical_care: '',
			// 				pay_birth: '',
			// 				pay_large_treatment: '',
			// 				pay_commonMpe: '',
			// 				flag: 0
			// 			}];
			this.form.city_id = '';
			this.form.minimum_wage = '';
			// 养老
			this.form.provideAged_base = '';
			this.form.provideAged_pay_type = '';
			this.form.provideAged_proportion = '';
			// 失业
			this.form.unemployment_base = '';
			this.form.unemployment_pay_type = '';
			this.form.unemployment_proportion = '';
			// 工伤
			this.form.industrial_injury_base = '';
			this.form.industrial_injury_type = '';
			this.form.industrial_injury_proportion = '';
			// 医疗
			this.form.medical_care_base = '';
			this.form.medical_care_pay_type = '';
			this.form.medical_care_proportion = '';
			// 生育
			this.form.birth_base = '';
			this.form.birth_pay_type = '';
			this.form.birth_proportion = '';
			// 大额医疗
			this.form.large_treatment_base = '';
			this.form.large_treatment_pay_type = '';
			this.form.large_treatment_proportion = '';
			this.form.large_treatment_month = '';
			// 公积金
			this.form.commonMpe_base = '';
			this.form.commonMpe_pay_type = '';
			this.form.commonMpe_proportion = '';
		}
	},
	async created() {
		this.Find();
	},
};
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
	background: #006e4b;
	border-color: #05573d;
	color: #fff;
}

.el-button--addbtn:focus,
.el-button--addbtn:hover {
	background: #fff;
	border-color: #05573d;
	color: #006e4b;
}

.el-button--goon {
	color: #fff;
	background-color: #006e4b;
	border-color: #006e4b;
	font-size: 15px;
	width: 85px;
}

.el-button--addbtn {
	color: #006e4b;
	background-color: #fff;
	border-color: #006e4b;
	font-size: 15px;
	width: 85px;
}

.el-table .warning-row {
	background: oldlace;
}

.el-table .success-row {
	background: #f0f9eb;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: #006e4b;
	border-color: #006e4b;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #006e4b;
}

.el-checkbox__inner:hover {
	border-color: #006e4b;
}

.el-button--pic {
	color: #006E4B;
	background-color: #fff;
	border-color: #006E4B;
	font-size: 10px;
	height: 30px;
	width: 80px;
	padding: 10px;
}

.el-button--pic:focus,
.el-button--pic:hover {
	background: #fff;
	border-color: #05573d;
	color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// Bxjsgl.vue?d4c9c69a